import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { NewinterviewreviewComponent } from './newinterviewreview/newinterviewreview.component';
import { InterviewratingComponent } from './interviewrating/interviewrating.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthService } from './auth/login/auth.service';
import { AppService } from './app.service';
import { InterviewService } from './newinterviewreview/interview.service';
import { GetdataService } from './interviewrating/getdata.service';

import { Routes , RouterModule} from '@angular/router';
import { InterviewdetailComponent } from './interviewdetail/interviewdetail.component';
import { InterviewdetailService } from './interviewdetail/interviewdetail.service';
import { AlertmessagesService } from './alertmessages.service';
import { HomepageComponent } from './homepage/homepage.component';

const routes: Routes = [

  {path: '', component: HomepageComponent},
 {path: 'home', component: HeaderComponent},
  {path: 'interview', component: NewinterviewreviewComponent},
  {path: 'login', component: LoginComponent },
  {path: 'interviewrating', component: InterviewratingComponent},
  {path: 'interviewdetail', component: InterviewdetailComponent }
]; 

@NgModule({
  declarations: [
    AppComponent,
    NewinterviewreviewComponent,
    InterviewratingComponent,
    HeaderComponent,
    LoginComponent,
    InterviewdetailComponent,
    HomepageComponent
  ],


  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
 
    RouterModule.forRoot(routes)

  ],
  providers: [AuthService, AppService, InterviewService,GetdataService,InterviewdetailService,AlertmessagesService],
  bootstrap: [AppComponent]
})
export class AppModule {




 }



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/app.module.ts